export const RESPONSE_URL_RE =
  /\/(?:answers|basic-dialog|processes-blocks|handoffs)\/([a-f0-9]{24})/;
